(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

    (function () {
    const mq = window.matchMedia('(min-width: 750px)');
    const root = document.querySelector('[data-section-type="footer"]');
    if (!root) return;

    const detailsList = root.querySelectorAll('details.footer-acc');

    const sync = () => {
      detailsList.forEach(d => {
        if (mq.matches) {
          d.open = true;  // desktop: always open
        } else {
          d.open = false; // mobile: closed by default
        }
      });
    };

    sync();
    mq.addEventListener?.('change', sync);
  })();

  } catch(e) { console.error(e); }
})();
})();
